/* loaded by smart-asset */
export default require("./assets/conveyor-reflected.i.svg")